import { render } from "./FrameMix.vue?vue&type=template&id=43f284c4&scoped=true"
import script from "./FrameMix.vue?vue&type=script&lang=js"
export * from "./FrameMix.vue?vue&type=script&lang=js"

import "./FrameMix.vue?vue&type=style&index=0&id=43f284c4&scoped=true&lang=css"

import exportComponent from "/home/goat/dev/framemix/framemix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f284c4"]])

export default __exports__